"use client";

import { useEffect, useState } from "react";

const TEAL = "#4FCDC4";
const TEXT_MUTED = "#a0a0a0";

const FADE_THRESHOLD = 240;

// Hero scroll hint. Sits at the bottom-right of the term header to
// counterbalance the category pill in the top-left. Fades to 0 once the
// user has scrolled past the hero so it stops competing with body content.
// Hidden on mobile (<=768px) via the `.glossary-keep-reading` class.
export default function KeepReading({ targetId = "glossary-content" }) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    function onScroll() {
      setHidden(window.scrollY > FADE_THRESHOLD);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={`#${targetId}`}
      className="glossary-keep-reading"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        color: TEXT_MUTED,
        fontFamily: "var(--body)",
        fontSize: 13,
        fontWeight: 500,
        letterSpacing: "0.02em",
        textDecoration: "none",
        opacity: hidden ? 0 : 1,
        transition: "opacity 0.4s ease, color 0.2s ease",
        pointerEvents: hidden ? "none" : "auto",
      }}
      onMouseOver={(e) => {
        if (!hidden) e.currentTarget.style.color = TEAL;
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.color = TEXT_MUTED;
      }}
    >
      Keep reading
      <span
        aria-hidden="true"
        className="glossary-keep-reading-arrow"
        style={{ display: "inline-block", fontSize: 14, lineHeight: 1 }}
      >
        ↓
      </span>
      <style>{`
        @keyframes glossaryKeepReadingArrow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(4px); }
        }
        .glossary-keep-reading-arrow {
          animation: glossaryKeepReadingArrow 2s ease-in-out infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .glossary-keep-reading-arrow { animation: none; }
        }
        @media (max-width: 768px) {
          .glossary-keep-reading { display: none !important; }
        }
      `}</style>
    </a>
  );
}
